// usePaymentMethods stub - Payment integrations simplified

export function usePaymentMethods(_companyId?: string) {
  return {
    data: [],
    isLoading: false
  };
}

export function useDeletePaymentMethod() {
  return {
    mutateAsync: async (_params: { id: string; companyId: string }) => ({ success: false }),
    isPending: false
  };
}

export function useSetDefaultPaymentMethod() {
  return {
    mutateAsync: async (_params: { id: string; companyId: string }) => ({ success: false }),
    isPending: false
  };
}

export default usePaymentMethods;
